<template>
  <div class="home">
    <Row>
      <Col span="11">
        <Card class="realname">
          <p slot="title">Hi，{{accountInfo.contact}}<Tag color="success" v-if="accountInfo.passCode === 2">已实名</Tag></p>
          <template v-if="accountInfo.passCode === 404">
            <List>
              <ListItem>
                <ListItemMeta title="实名认证后才能进行推广收益喔~" >
                  <Icon type="md-bulb" size="28" slot="avatar" />
                </ListItemMeta>
                <Button @click="$router.push({ path: '/realname' })">前往实名认证</Button>
              </ListItem>
            </List>
          </template>
          <template v-if="accountInfo.passCode === 0">
            <List>
              <ListItem>
                <ListItemMeta title="实名认证中，认证后才能进行收益提现" description="工作人员将会在1-3个工作日内核实您的信息，请保持您的电话号码畅通" >
                  <Icon type="ios-loading" size="28" class="spin-icon-load" slot="avatar" />
                </ListItemMeta>
                <Button @click="$router.push({ path: '/realname?step=2' })">查看进度</Button>
              </ListItem>
            </List>
          </template>
          <template v-if="accountInfo.passCode === 1">
            <List>
              <ListItem>
                <ListItemMeta title="认证失败" description="你提交的资料审核未通过，点击查看详情" >
                  <Icon type="ios-close-circle-outline" slot="avatar" size="28" />
                </ListItemMeta>
                <Button @click="$router.push({ path: '/realname?step=3' })">查看详情</Button>
              </ListItem>
            </List>
          </template>
          <template v-if="accountInfo.passCode === 2">
            <Row>
              <Col span="11">
                <div class="pd12" @click="$router.push({ path: '/effect/effectStudent' })">
                  <span class="fz28">{{regNum}}</span>
                  <span>人</span>
                  <p>本月注册</p>
                </div>
              </Col>
              <Col span="11" offset="2">
                <div class="pd12" @click="$router.push({ path: '/effect/effectOrder?type=2' })">
                  <span class="fz28">{{orderNum}}</span>
                  <p>本月成交订单</p>
                </div>
              </Col>
            </Row>
          </template>
        </Card>
      </Col>
      <Col span="11" offset="2">
        <Card>
          <p slot="title">邀请推广</p>
          <template v-if="accountInfo.passCode === 404">
            <List>
              <ListItem class="pd12">
                <ListItemMeta title="暂无推广代码" description="实名认证后，可进行分享赚钱" />
              </ListItem>
            </List>
          </template>
          <template v-else>
            <List>
              <ListItem class="pd12">
                <ListItemMeta title="通过专属链接邀请购课成功获得收益" />
                <Button @click="$router.push({ path: '/generalize' })">立即前往</Button>
              </ListItem>
            </List>
          </template>
        </Card>
      </Col>
    </Row>
    <Row>
      <Col span="24" class="order">
        <h3>本月产生订单</h3>
        <Table :loading="orderLoading" border :columns="orderColumns" :data="orderData"></Table>
        <div class="more" v-if="orderData.length > 0">
          <router-link to="/effect/effectOrder">全部订单</router-link>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      regNum: 0,
      orderNum: 0,
      orderLoading: true,
      orderColumns: [
        {
          title: "订单编号",
          key: "orderID",
          width: 160
        },
        {
          title: "用户名",
          key: "userName",
        },
        // {
        //   title: "姓名",
        //   key: "trueName",
        // },
        // {
        //   title: "手机号码",
        //   key: "mobilePhone",
        // },
        {
          title: "订单金额",
          key: "classMoney",
        },
        {
          title: "实付金额",
          key: "payMoney",
        },
        {
          title: "订单状态",
          key: "payStatus",
          render: (h, params) => {
            if (params.row.payStatus === 1) {
              return h("span", {
                style: {
                  color: '#bebebe'
                }
              }, "未支付")
            } else if (params.row.payStatus === 3) {
              return h("span", {
                style: {
                  color: '#FF9900'
                }
              }, "已支付")
            } else if (params.row.payStatus === 6) {
              return h("span", {
                style: {
                  color: '#a569f1'
                }
              }, "已退款")
            }
          }
        },
        {
          title: "报名时间",
          key: "addTime",
          width: 200
        },
        {
          title: "支付时间",
          key: "payTime",
          width: 200
        }
      ],
      orderData: []
    }
  },
  computed: {
    accountInfo() {
      return this.$store.getters['account/accountInfo']
    }
  },
  created() {
    this.$store.dispatch('effect/studentStatic').then(res => {
      this.regNum = res.monthRegisterCount
    })
    this.$store.dispatch('effect/orderStatic').then(res => {
      this.orderNum = res.monthOrderCount
    })
    this.$store.dispatch("effect/orderList", { "type": 0, "startTime": this.getMonthFirstDay(), "endTime": this.getMonthLastDay(), "pgIndex": 1, "pgSize": 10 }).then(res => {
      if (res.s === 10006) {
        this.orderLoading = false
        this.orderData = res.list
      } else {
        this.orderLoading = false
        this.orderData = []
      }
    })
  },
  methods: {
    getMonthFirstDay() {
      const Nowdate = new Date()
      const MonthFirstDay = new Date(Nowdate.getFullYear(), Nowdate.getMonth(), 1)
      const M = Number(MonthFirstDay.getMonth()) + 1
      return MonthFirstDay.getFullYear() + "-" + M + "-" + MonthFirstDay.getDate()
      //  + " 00:00:00"
    },
    getMonthLastDay() {
      const Nowdate = new Date()
      const MonthNextFirstDay = new Date(Nowdate.getFullYear(), Nowdate.getMonth() + 1, 1)
      const MonthLastDay = new Date(MonthNextFirstDay - 86400000)
      const M = Number(MonthLastDay.getMonth()) + 1
      return MonthLastDay.getFullYear() + "-" + M + "-" + MonthLastDay.getDate()
      //  + " 23:59:59"
    }
  }
}
</script>

<style lang="scss" scoped>
.realname{
  .ivu-card-head{
    p{
      .ivu-tag{
        margin-left: 12px;
      }
    }
  }
  .ivu-card-body{
    .ivu-row{
      .ivu-col{
        text-align: center;
        cursor: pointer;
        &:hover{
          background: #f4f4f4;
        }
      }
    }
  }
}
.order{
  h3{
    margin: 24px 0 10px;
  }
  .more{
    width: 100%;
    height: 40px;
    line-height: 39px;
    border: 1px solid #dcdee2;
    border-top: none;
    a{
      display: inline-block;
      width: 100%;
      height: 100%;
      text-align: center;
    }
  }
}
.pd12{
  padding: 12px;
}
.fz28{
  color: #e13b29;
  font-size: 28px;
}
a{
  color: #e13b29;
}
.ivu-card{
  .ivu-card-head{
    p{
      height: 24px;
      line-height: 24px;
    }
  }
}
.spin-icon-load{
  animation: ani-spin 1s linear infinite;
}
@keyframes ani-spin {
  from { transform: rotate(0deg);}
  50%  { transform: rotate(180deg);}
  to   { transform: rotate(360deg);}
}
</style>